// Import model
import { UpdateProjectRequest } from '../models/UpdateProjectRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateProjectRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateProjectRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateProjectRequest instance
   */
  static deserialize(json: string): UpdateProjectRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateProjectRequest instance
   */
  static fromObject(obj: any): UpdateProjectRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateProjectRequest');
    }


    const instance: UpdateProjectRequest = {
      description: obj['description'] as string | undefined,
      name: obj['name'] as string | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      roomNames: obj['roomNames'] ? (obj['roomNames'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateProjectRequest instances
   */
  static deserializeArray(json: string): UpdateProjectRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateProjectRequest instance to a JSON string
   */
  static serialize(instance: UpdateProjectRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateProjectRequest instance to a plain object
   */
  static toObject(instance: UpdateProjectRequest): any {
    return {
      'description': instance.description,
      'name': instance.name,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
      'roomNames': instance.roomNames?.map((item: any) =>
        item
      ),
    };
  }

  /**
   * Serializes an array of UpdateProjectRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateProjectRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
